import { IconButton } from "@mui/material";
import { Result } from "antd";
import React from "react";
import LinkedInIcon from "@mui/icons-material/LinkedIn";
import InstagramIcon from "@mui/icons-material/Instagram";

const CompletedPage = () => {
  return (
    <div className="flex_center">
      <Result
        status="success"
        title={
          <>
            <p>Thank you for applying to RecProtect.</p>
          </>
        }
        subTitle="We will be in touch shortly for next steps!"
        extra={
          <>
            <p>Follow us on</p>
            <IconButton>
              <LinkedInIcon />
            </IconButton>
            <IconButton>
              <InstagramIcon />
            </IconButton>
          </>
        }
      />
    </div>
  );
};

export default CompletedPage;
